import style from './index.module.scss';
import { MyProfileAvatar } from '@/components/my-profile-avatar';
import { QuickActionsNav } from '@/components/quick-actions-nav';
import { cn } from '@/utils/utils.ts';
import { PlantRanking } from '@/features/dashboard/components/admin/plant-ranking.tsx';
import { Events } from '@/features/dashboard/components/events/events.tsx';
import { PerformanceMonitoring } from '@/features/dashboard/components/admin/performance-monitoring.tsx';
import { useTranslation } from 'react-i18next';

export const AdvancedDashboardPage = () => {
  const { t } = useTranslation();

  return (
    <div className={cn(style.overview, `w-full gap-2 overflow-auto px-4 pt-3 pb-4 sm:px-6`)}>
      <div className="flex flex-col gap-6">
        <div className="flex h-[45px] items-center justify-between">
          <h1 className="text-xl font-bold sm:text-2xl">{t('navigation.menu.dashboard')}</h1>
          <div className="flex gap-2">
            <QuickActionsNav />
            <MyProfileAvatar />
          </div>
        </div>
        <div className={cn(style.cards_grid, 'gap-6')}>
          <PerformanceMonitoring className={cn(style.performance_monitoring)} />
          <PlantRanking className={cn(style.plant_ranking)} />
          <Events className={cn(style.reports)} />
        </div>
      </div>
    </div>
  );
};
